import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../../types';
import { SERIF_FONT } from './proseStyle';

/**
 * 章扉のエピグラフ（題辞）。章タイトル直後・本文の前に置く、
 * 短い引用 + 出典の特別な引用。字下げ・小さめ・右寄せ気味で本文と区別する。
 * ProseQuote と違い「章の冒頭に置く出典付きの一撃」を担う。
 * params: text（joined, 引用文。Markdown 可）、cite（任意, 出典）
 */
export const ProseEpigraph: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const text = (node.params.text as string) ?? '';
  const cite = (node.params.cite as string) ?? '';

  return (
    <Box sx={{ pl: 4, pr: 1, my: 3, textAlign: 'right' }}>
      <Typography
        component="div"
        sx={{
          fontSize: 13,
          fontStyle: 'italic',
          fontFamily: SERIF_FONT,
          color: '#555',
          lineHeight: 1.9,
          '& .wmde-markdown, & .wmde-markdown p, & .wmde-markdown span': {
            margin: 0,
            fontFamily: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            color: 'inherit',
            background: 'transparent',
          },
        }}
      >
        {renderInline(text)}
      </Typography>
      {cite && (
        <Typography
          component="div"
          sx={{
            fontSize: 11,
            fontFamily: SERIF_FONT,
            color: '#999',
            mt: 0.5,
          }}
        >
          ― {cite}
        </Typography>
      )}
    </Box>
  );
};

export default ProseEpigraph;
